import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminFeedbackHeader from "./AdminFeedbackHeader";

export default function AdminFeedBack() {
  const [records, setRecords] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  const fetchData = async () => {
    try {
      const res = await axios.get(
        "https://api.dremerz.net/api/DZ_8921_smcproject_feedbacktable_feedbacklist"
      );
      setRecords(res.data);
    } catch (err) {
      alert("Error fetching records");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      await axios.delete(
        `https://api.dremerz.net/api/DZ_8921_smcproject_feedbacktable_feedbacklist/${id}`
      );
      fetchData();
    } catch {
      alert("Error deleting record");
    }
  };

  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const startEdit = (record) => {
    setEditingId(record.id);
    setEditData(record);
  };

  const saveEdit = async () => {
    try {
      await axios.put(
        `https://api.dremerz.net/api/DZ_8921_smcproject_feedbacktable_feedbacklist/${editingId}`,
        editData
      );
      setEditingId(null);
      fetchData();
    } catch {
      alert("Error updating record");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <AdminFeedbackHeader />
      <div className="container mt-5">
        <h3>Admin Panel - Feedback Records</h3>
        <table className="table table-bordered table-striped mt-3">
          <thead style={{ backgroundColor: "#04143B", color: "#fff" }}>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Description</th>
              <th>Date</th>
              <th>Time</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records.toReversed().map((rec) => (
              <tr key={rec.id}>
                <td>
                  {editingId === rec.id ? (
                    <input
                      name="name"
                      value={editData.name}
                      onChange={handleEditChange}
                      className="form-control"
                    />
                  ) : (
                    rec.name
                  )}
                </td>
                <td>
                  {editingId === rec.id ? (
                    <input
                      name="mobile"
                      value={editData.mobile}
                      onChange={handleEditChange}
                      className="form-control"
                    />
                  ) : (
                    rec.mobile
                  )}
                </td>
                <td>
                  {editingId === rec.id ? (
                    <input
                      name="description"
                      value={editData.description}
                      onChange={handleEditChange}
                      className="form-control"
                    />
                  ) : (
                    rec.description
                  )}
                </td>
                <td>{rec.currentDate}</td>
                <td>{rec.currentTime}</td>
                <td>
                  {editingId === rec.id ? (
                    <>
                      <button
                        onClick={saveEdit}
                        className="btn btn-success btn-sm me-2"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => setEditingId(null)}
                        className="btn btn-secondary btn-sm"
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => startEdit(rec)}
                        className="btn btn-warning btn-sm me-2"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(rec.id)}
                        className="btn btn-danger btn-sm"
                      >
                        Delete
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
